// extracted by mini-css-extract-plugin
module.exports = {"Gitex":"gitex-exhibition-2024_Gitex__oOS3a"};